import React from 'react';
import { Toaster } from 'sonner';
import { useTheme } from '../contexts/ThemeContext';
import { useUpdateToast } from '../lib/updateToast';

/** Mounts the sonner toaster and the update-available watcher (once, in App). */
export default function UpdateToastHost() {
  const { theme } = useTheme();
  useUpdateToast();
  return <Toaster theme={theme} position="bottom-right" />;
}
